import styled, { css } from 'styled-components';

export const RadioStyled = styled.div`
  label {
    display: flex;
    align-items: center;
    gap: ${props => (props.size === 'large' ? '16px' : '8px')};
    cursor: pointer;
  }

  .hiddenRadio {
    display: none;
  }

  .hiddenRadio:checked + .showRadio {
    background: var(--Primary-500);
    background-size: contain;
    border-radius: 100px;
    border: 1px solid var(--Primary-500);
    .showRadioInner {
      border-radius: 100px;
      background: #ffffff;
    }
    transition: 0.2s;
  }

  .showRadio {
    width: 16px;
    height: 16px;
    min-width: 16px;
    border-radius: 100px;
    border: 1px solid #cccccc;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    // background: url("https://blog.kakaocdn.net/dn/LAusM/btrMrxQ8kW2/KUj97kbGvSI8RvwK5Kjqak/img.png") no-repeat;
    background-size: contain;
    transition: 0.2s;
  }

  ${props => {
    let styles = '';
    if (props.size == 'large') {
      styles += `
            .showRadio {
                width: 24px;
                height: 24px;
            }
            .showRadioInner {
                width: 10px;
                height: 10px;
            }

        `;
    } else if (props.size == 'medium') {
      styles += `
            .showRadio {
                width: 20px;
                height: 20px;
            }
            .showRadioInner {
                width: 8px;
                height: 8px;
            }

        `;
    } else if (props.size == 'small') {
      styles += `
            .showRadio {
                width: 16px;
                height: 16px;
            }
            .showRadioInner {
                width: 6px;
                height: 6px;
            }

        `;
    }
    if (props.disabled) {
      styles += `
        .showRadio {
            background: #CCCCCC;
        }

        .hiddenRadio:checked + .showRadio {
          background: var(--Primary-500);
          background-size: contain;
          border-radius: 100px;
          border: 1px solid var(--Primary-500);
          .showRadioInner {
            border-radius: 100px;
            background: #ffffff;
          }
          transition: 0.2s;
        }


        label {
          cursor: inherit;
        }
      `;
    }

    return css`
      ${styles}
    `;
  }}
`;
